<template>
    <v-group>
        <v-text ref="infoBox" :config="infoTextConfig"></v-text>

        <v-line :config="hLineConfig"></v-line>

        <v-text ref="statusBox" :config="trimStatusTextConfig"></v-text>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: "PaintColorPlaceholder",

        props: [
            'totalBoxWidth',
            'trimName',
            'paintName',
            'textColor',
            'lineColor',
            'padding',
            'fontSize',
        ],

        emits: [
            'textBoxHeight',
        ],

        data() {
            return {
                infoBoxHeight: 100,
            }
        },

        computed: {
            ...mapState('trimInfo', [
                'isTrimExported',
            ]),

            ...mapGetters('editor', [
                'trimTotalLength',
            ]),

            infoBoxRef() {
                // get the object node to work with its properties
                return this.$refs.infoBox?.getNode() || {};
            },

            statusBoxRef() {
                // get the object node to work with its properties
                return this.$refs.statusBox?.getNode() || {};
            },

            placeholderText() {
                let paintText = this.paintName ? `\n ${this.paintName}` : '';

                return ` ${this.trimName} \n ${this.trimTotalLength}" ${paintText}`;
            },

            infoTextConfig() {
                return {
                    x: this.padding,
                    y: this.padding - (this.padding / 4),
                    width: this.totalBoxWidth - (this.padding * 2),
                    text: this.placeholderText,
                    fontSize: this.fontSize,
                    fontFamily: 'fontello, Arial, sans-serif',
                    lineHeight: 1.2,
                    wrap: 'word',
                    fill: this.textColor,
                }
            },

            trimStatusTextConfig() {
                let yOffset = this.infoBoxHeight + this.padding;
                let text = ' ' + (this.isTrimExported ? 'EXPORTED' : 'DRAFT');
                // let fill = this.isTrimExported ? '#ad0100' : this.textColor;

                return {
                    x: this.padding,
                    y: this.padding - (this.padding / 4) + yOffset,
                    width: this.totalBoxWidth - (this.padding * 2),
                    text,
                    fontSize: this.fontSize,
                    fontFamily: 'fontello, Arial, sans-serif',
                    lineHeight: 1.2,
                    fill: this.textColor,
                }
            },

            hLineConfig() {
                let yPos = Math.round(+this.infoBoxHeight + +this.padding);

                return {
                    y: yPos,
                    points: [0, 0, this.totalBoxWidth, 0],
                    stroke: this.lineColor,
                    strokeWidth: 1,
                }
            },

        },

        methods: {
            getTextBoxSize() {
                // get the correct size of the rendered text
                let infoBoxHeight = this.infoBoxRef.height();
                let statusBoxHeight = this.statusBoxRef.height();

                let textBoxHeight = Math.round(infoBoxHeight + statusBoxHeight + this.padding * 2.5);

                this.infoBoxHeight = infoBoxHeight;

                this.$emit('textBoxHeight', textBoxHeight);
            },

        },

        watch: {
            placeholderText() {
                // use $nextTick to wait for rendering
                this.$nextTick(this.getTextBoxSize);
            },

        },

        mounted() {
            this.getTextBoxSize();
        },

    }
</script>

<style scoped>

</style>